import React from "react";
import { SearchProvider, SearchBox } from "@elastic/react-search-ui";
import PropTypes from "prop-types";
import searchConnector from "../../config/searchConnector";
import Autocomplete from "../Autocomplete/Autocomplete";
import SearchInputView from "../SearchInputView/SearchInputView";
import { searchPerformed } from "../../lib/analytic/trackSearch";

const searchConfig = {
  debug: false,
  apiConnector: searchConnector,
  autocompleteQuery: {
    suggestions: {
      filters: [
        {
          field: "type",
          type: "any",
          values: ["Capabilities", "Events", "Resources", "Solutions"],
        },
      ],
      top: 5,
    },
  },
};

const url = "/search";

const SearchBlock = ({ focusInputSearch, placeholderText, typeOfSearch }) => {
  return (
    <SearchProvider config={searchConfig}>
      <SearchBox
        autocompleteMinimumCharacters={2}
        autocompleteSuggestions
        autocompleteView={(props) => <Autocomplete {...props} />}
        inputView={(props) => (
          <SearchInputView
            {...props}
            focusInputSearch={focusInputSearch}
            placeholderText={placeholderText}
          />
        )}
        onSubmit={(searchTerm) => {
          if (searchTerm.length > 0) {
            searchPerformed(typeOfSearch, searchTerm);
            window.location.assign(
              `${url}?q=${encodeURIComponent(searchTerm)}`
            );
          }
        }}
        /* eslint-disable-next-line no-empty-pattern */
        onSelectAutocomplete={(selection, {}, defaultOnSelectAutocomplete) => {
          if (selection.suggestion) {
            searchPerformed(typeOfSearch, selection.suggestion);
            defaultOnSelectAutocomplete(selection);
            window.location.assign(`${url}?q=${selection.suggestion}`);
          } else {
            defaultOnSelectAutocomplete(selection);
          }
        }}
      />
    </SearchProvider>
  );
};

SearchBlock.defaultProps = {
  focusInputSearch: false,
  typeOfSearch: "",
  placeholderText: "",
};

SearchBlock.propTypes = {
  focusInputSearch: PropTypes.bool,
  placeholderText: PropTypes.string,
  typeOfSearch: PropTypes.string,
};

export default SearchBlock;
